export const WINDOW_PROTOCOL = "lcf-translation-window-v1";
const isRecord = value => !!value && typeof value === "object" && !Array.isArray(value);
const validStyle = (key, value) => {
  if (["fontSize", "padding", "borderRadius"].includes(key)) {
    return Number.isFinite(value) && (key === "fontSize" ? value > 0 : value >= 0);
  }
  return typeof value === "string";
};
const STYLE_KEYS = ["fontSize", "padding", "borderRadius", "textColor", "bgColor"];

export const readWindowJSON = (key) => {
  try {
    const value = JSON.parse(localStorage.getItem(key) || "{}");
    return value && typeof value === "object" && !Array.isArray(value) ? value : {};
  } catch {
    return {};
  }
};

const pickMessage = (value) => {
  if (!isRecord(value)) return { enabled: false, text: "" };
  return {
    enabled: value.enabled === true,
    text: typeof value.text === "string" ? value.text : "",
    ...Object.fromEntries(STYLE_KEYS.filter(key => validStyle(key, value[key])).map(key => [key, value[key]])),
  };
};

// Explicit allowlist: never send tokens, profile data, or unrelated localStorage.
export const readPresenterSnapshot = (windowId) => {
  const shared = readWindowJSON("translationWindowSettings");
  const suffix = windowId === 2 ? "2" : "";
  return {
    settings: {
      header: pickMessage(shared.header), footer: pickMessage(shared.footer),
      overlayMode: typeof shared.overlayMode === "boolean" ? shared.overlayMode : false,
    },
    translation: {
      text: localStorage.getItem(`currentTranslation${suffix}`) || "",
      timestamp: Number(localStorage.getItem(`translationTimestamp${suffix}`)) || 0,
    },
    readingSpeed: Number(localStorage.getItem("translationWindow_readingSpeed")) || 15,
  };
};

export const isPresenterSnapshot = (value) => {
  if (!isRecord(value) || !isRecord(value.settings) || !isRecord(value.translation)) return false;
  const validBox = box => isRecord(box) && (
    typeof box.enabled === "boolean" && typeof box.text === "string"
    && STYLE_KEYS.every(key => box[key] === undefined || validStyle(key, box[key]))
  );
  return validBox(value.settings.header) && validBox(value.settings.footer)
    && typeof value.settings.overlayMode === "boolean"
    && typeof value.translation.text === "string" && Number.isFinite(value.translation.timestamp)
    && value.translation.timestamp >= 0
    && Number.isFinite(value.readingSpeed);
};